/**
 * The todo list-ordering vocabulary, in a module that imports nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts`: `router.tsx` imports every
 * route's `validateSearch` schema EAGERLY, so what a search module reaches for
 * lands in the initial chunk. `my-todos.route.search.ts` and
 * `admin-todos.route.search.ts` sort on these two, and reaching for the Zod
 * enums pulled `schemas/todo.schema.ts` (and, behind it, the shared todo row)
 * into the initial chunk of an app most of whose users open the todos page
 * later, or never.
 *
 * Status and priority are the shared vocabulary and live in
 * `@/shared/todos/todo-vocabulary`; these two are the todos feature's own.
 *
 * The tuples are the single source of truth: `schemas/todo.schema.ts` builds
 * its Zod enums from them, so the URL parser and the wire parser cannot drift.
 */

export const TODO_SORT_FIELDS = [
  "sortOrder",
  "createdAt",
  "dueDate",
  "priority",
  "updatedAt",
] as const;
export type TodoSortFieldName = (typeof TODO_SORT_FIELDS)[number];

export const TODO_SORT_DIRS = ["asc", "desc"] as const;
export type TodoSortDirName = (typeof TODO_SORT_DIRS)[number];
